//普通节点表单验证数据
export const ordinaryNodeFormVerify = {
    nodeId: [
        {
            required: true,
            message: "节点id不能为空!",
            trigger: "blur",
        },
    ],
    nodeName: [
        {
            required: true,
            message: "节点名称不能为空!",
            trigger: "blur",
        },
    ],
    auditType: [
        {
            required: true,
            message: "请选择审核方式!",
            trigger: "change",
        },
    ],
    auditKey: [
        {
            required: true,
            message: "请选择审核人员/角色/部门/岗位!",
            trigger: "change",
        },
    ],
}

//会签节点表单验证数据
export const countersignNodeFormVerify = {
    nodeId: [
        {
            required: true,
            message: "节点id不能为空!",
            trigger: "blur",
        },
    ],
    nodeName: [
        {
            required: true,
            message: "节点名称不能为空!",
            trigger: "blur",
        },
    ],
    auditType: [
        {
            required: true,
            message: "请选择审核方式!",
            trigger: "change",
        },
    ],
    auditKey: [
        {
            required: true,
            message: "请选择审核人员/角色/部门/岗位!",
            trigger: "change",
        },
    ],

    countersignWay: [
        {
            required: true,
            message: "请选择会签方式!",
            trigger: "change",
        },
    ],
    countersignOrder: [
        {
            required: true,
            message: "请选择会签顺序!",
            trigger: "change",
        },
    ],
}

//条件会签节点表单验证数据
export const conditionCountersignNodeFormVerify = {
    nodeId: [
        {
            required: true,
            message: "节点id不能为空!",
            trigger: "blur",
        },
    ],
    nodeName: [
        {
            required: true,
            message: "节点名称不能为空!",
            trigger: "blur",
        },
    ],
    auditType: [
        {
            required: true,
            message: "请选择审核方式!",
            trigger: "change",
        },
    ],
    auditKey: [
        {
            required: true,
            message: "请选择审核人员/角色/部门/岗位!",
            trigger: "change",
        },
    ],

    countersignWay: [
        {
            required: true,
            message: "请选择会签方式!",
            trigger: "change",
        },
    ],
    countersignOrder: [
        {
            required: true,
            message: "请选择会签顺序!",
            trigger: "change",
        },
    ],

    conditionValue: [
        {
            required: true,
            message: "请选择流转条件!",
            trigger: "change",
        },
    ],
}

//条件节点表单验证数据
export const conditionNodeFormVerify = {
    nodeId: [
        {
            required: true,
            message: "节点id不能为空!",
            trigger: "blur",
        },
    ],
    nodeName: [
        {
            required: true,
            message: "节点名称不能为空!",
            trigger: "blur",
        },
    ],
    auditType: [
        {
            required: true,
            message: "请选择审核方式!",
            trigger: "change",
        },
    ],
    auditKey: [
        {
            required: true,
            message: "请选择审核人员/角色/部门/岗位!",
            trigger: "change",
        },
    ],
    conditionValue: [
        {
            required: true,
            message: "请选择流转条件!",
            trigger: "change",
        },
    ],
}

//决策节点表单验证数据
export const decisionNodeFormVerify = {
    nodeId: [
        {
            required: true,
            message: "节点id不能为空!",
            trigger: "blur",
        },
    ],
    nodeName: [
        {
            required: true,
            message: "节点名称不能为空!",
            trigger: "blur",
        },
    ],
    auditType: [
        {
            required: true,
            message: "请选择审核方式!",
            trigger: "change",
        },
    ],
    auditKey: [
        {
            required: true,
            message: "请选择审核人员/角色/部门/岗位!",
            trigger: "change",
        },
    ],
    conditionValue: [
        {
            required: true,
            message: "请选择流转条件!",
            trigger: "change",
        },
    ],
}

//用户数据
export const userData = [
    {
        userId: "1",
        userName: "张三",
    },
    {
        userId: "2",
        userName: "李四",
    },
    {
        userId: "3",
        userName: "王五",
    },
    {
        userId: "4",
        userName: "赵六",
    },
    {
        userId: "5",
        userName: "王二",
    },

];

//角色数据
export const roleData = [
    {
        roleId: "1",
        roleName: "管理员",
    },
    {
        roleId: "2",
        roleName: "普通用户",
    },
    {
        roleId: "3",
        roleName: "操作员",
    },
];

//部门数据
export const departmentData = [
    {
        departmentId: "1",
        departmentName: "部门1",
    },
    {
        departmentId: "2",
        departmentName: "部门2",
    },
    {
        departmentId: "3",
        departmentName: "部门3",
    },
];

//岗位数据
export const postData = [
    {
        postId: "1",
        postName: "岗位1",
    },
    {
        postId: "2",
        postName: "岗位2",
    },
    {
        postId: "3",
        postName: "岗位3",
    },
]

//条件数据
export const conditionData = [
    {
        conditionId: "请假天数<=1天",
        conditionName: "请假天数<=1天",
    },
    {
        conditionId: "请假天数>1天 && 请假天数<=3天",
        conditionName: "请假天数>1天 && 请假天数<=3天",
    },
    {
        conditionId: "请假天数>3天",
        conditionName: "请假天数>3天",
    },
]

//采购审批条件数据
export const purchaseConditionData = [
    {
        purchaseConditionId: "金额<=1w",
        purchaseConditionName: "金额<=1w",
    },
    {
        purchaseConditionId: "金额>1w && 金额<=2w",
        purchaseConditionName: "金额>1w && 金额<=2w",
    },
    {
        purchaseConditionId: "金额>2w && 金额<=5w",
        purchaseConditionName: "金额>2w && 金额<=5w",
    },
    {
        purchaseConditionId: "金额>5w",
        purchaseConditionName: "金额>5w",
    },
]
